import { PostgreSqlCopySource } from './../../../pipeline/copysource/postgre-sql.copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PostgreSqlCopySource),
    asynchronous: true,
    disabled: __IS_FABRIC_DPE__,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class PostgreSqlCopySourceAdapter extends CopySourceAdapter<PostgreSqlCopySource, Model.PostgreSqlSource> {
    protected override async _toResource(copySource: PostgreSqlCopySource): Promise<Model.PostgreSqlSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(PostgreSqlCopySource).name);
    }

    protected override async _toModel(
        resource: Model.PostgreSqlSource,
        copyActivity: CopyActivity
    ): Promise<PostgreSqlCopySource> {
        return this._toTabularModel(resource, copyActivity, PostgreSqlCopySource.MODEL);
    }
}
